import React, { useEffect, useState } from 'react';
import ElapsedTimer from './ElapsedTimer';

const SOVEREIGN_SPLASH_LOGO = '/branding/legend-sovereign-stacked-navy.png';
const SPLASH_DURATION_MS = 5000;

export default function SplashScreen({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [startedAt] = useState(() => Date.now());

  useEffect(() => {
    const started = Date.now();
    const timer = window.setInterval(() => {
      const elapsed = Date.now() - started;
      const next = Math.min(100, Math.round((elapsed / SPLASH_DURATION_MS) * 100));
      setProgress(next);
      if (next >= 100) {
        window.clearInterval(timer);
        window.setTimeout(onComplete, 120);
      }
    }, 50);
    return () => window.clearInterval(timer);
  }, [onComplete]);

  return (
    <div className="min-h-screen bg-legend-navy text-legend-paper flex flex-col items-center justify-center px-6">
      <img
        src={SOVEREIGN_SPLASH_LOGO}
        alt="Legend Sovereign"
        className="w-full max-w-sm object-contain mb-8"
      />
      <div className="h-px w-24 bg-legend-gold/80 mb-8" aria-hidden="true" />
      <p className="text-center text-base sm:text-lg text-legend-paper/90 leading-relaxed max-w-2xl">
        Nation State Elicitation Modeling Tool
      </p>
      <div className="w-full max-w-xl mt-12">
        <div className="h-1.5 rounded-full bg-legend-deep border border-legend-teal/30 overflow-hidden">
          <div
            className="h-full bg-legend-teal transition-[width] duration-100 ease-linear"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="mt-3 flex flex-col items-center gap-1">
          <p className="text-center text-sm text-legend-teal-tint tracking-wide">
            Loading elicitation engine
          </p>
          <ElapsedTimer startedAt={startedAt} className="text-legend-slate" />
        </div>
      </div>
    </div>
  );
}
